import {
  KINDS,
  NO_TIME_KINDS,
  buildConfigs,
  buildGetConfigByKind
} from '@/shared/level-play/activities/config'

import { challenge as initialChallenge } from './Initial/config'

/**
 * Registro de kinds da jornada.
 *
 * O catálogo em si é compartilhado (`shared/level-play/activities/config`).
 * O que sobra aqui é o que é de domínio: a tela `initial`, que precisa do
 * registro do nível, e o `getConfig` com os caminhos de API da jornada.
 */

export { KINDS, NO_TIME_KINDS }

export const configs = buildConfigs([initialChallenge])
export const getConfigByKind = buildGetConfigByKind(configs)

export const icon = 'arrow-progress'
export const humanName = {
  singular: 'Nível',
  plural: 'Níveis'
}

export const getConfig = props => {
  const { digitalProductId } = props

  return {
    apiBasePath: `/user/digital_products/${digitalProductId}/levels`,
    humanName,
    icon,
    pagination: {
      per_page: 999
    },
    configs,
    getConfigByKind,
    KINDS
  }
}
